import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './par-language-communication.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ParLanguageCommunicationDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const parLanguageCommunicationEntity = useAppSelector(state => state.parLanguageCommunication.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="parLanguageCommunicationDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.parLanguageCommunication.detail.title">ParLanguageCommunication</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{parLanguageCommunicationEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.parLanguageCommunication.code">Code</Translate>
            </span>
          </dt>
          <dd>{parLanguageCommunicationEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.parLanguageCommunication.name">Name</Translate>
            </span>
          </dt>
          <dd>{parLanguageCommunicationEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.parLanguageCommunication.nameAr">nameAr</Translate>
            </span>
          </dt>
          <dd>{parLanguageCommunicationEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.parLanguageCommunication.nameEn">nameEn</Translate>
            </span>
          </dt>
          <dd>{parLanguageCommunicationEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.parLanguageCommunication.status">Status</Translate>
            </span>
          </dt>
          <dd>{parLanguageCommunicationEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/par-language-communication" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/par-language-communication/${parLanguageCommunicationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ParLanguageCommunicationDetail;
